import { useContext } from 'react';

//import FirebaseContext from '../contexts/FirebaseContext';
import AuthContext from '../contexts/KeycloakOauth2Context';
import {
  canKeyOpdOrderMedication as checkCanKeyOpdOrderMedication,
  hasAnyPermission as checkHasAnyPermission,
} from 'utility/permission.util';
//import JWTContext from '../contexts/JWTContext';
//import Auth0Context from '../contexts/Auth0Context';

//const useAuth = () => useContext(FirebaseContext);
//const useAuth = () => useContext(AuthContext)

const useAuth = () => {
  const context = useContext(AuthContext);

  // function เสริม
  const getConfig = (code) => {
    let {config} = context
    let result = null
    if(config){
        let cfg = config.find(({configCode})=>configCode===code)    
        
        if(cfg && cfg.data){
            result = cfg.data
        }
    }

    return result;
  };

  const getJsonConfig = (code) => {
    let {config} = context
    let result = null
    if(config){
        let cfg =config.find(({configCode})=>configCode===code)    
        
        if(cfg && cfg.jsonData){
            result = cfg.jsonData
        }
    }

    return result;
  };

  const hasAnyPermission = (rules = []) => {
    return checkHasAnyPermission(context?.user?.permissions, rules);
  };

  const canKeyOpdOrderMedication = () => {
    return checkCanKeyOpdOrderMedication(context?.user?.permissions);
  };

  return {
    ...context, // กระจายค่าที่มาจาก AuthContext
    getConfig,  // เพิ่ม function
    getJsonConfig,
    hasAnyPermission,
    canKeyOpdOrderMedication,
  };
};


export default useAuth;
